import React from 'react'
import { useSelector } from 'react-redux'
import { Col, Container, Row } from 'reactstrap'
import Sdk from '../sdk'

const DashboardIntegration = () => {
  const account = useSelector(state => state.accountReducers.account)

  return (
    <Container fluid>
      <Row className="py-4">
        <Col>
          <h1>Integration</h1>
        </Col>
      </Row>
      <Row className="py-4">
        {account &&
          <Sdk account={account} />
        }
      </Row>
    </Container>
  )
}

export default DashboardIntegration
